import { useRef, useState } from "react";
import BiodataPreview from "./BiodataPreview";
import html2canvas from "html2canvas";
import TemplateSelector from "./TemplateSelector";
import jsPDF from "jspdf";

export default function BiodataContainer({
  sections,
  template,
  userImage,
  onTemplateChange,
}) {
  const previewRef = useRef();
  const [imgLoaded, setImgLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const downloadPDF = async () => {
    if (!previewRef.current) return;

    if (!imgLoaded) {
      alert("Please wait until the template image is fully loaded");
      return;
    }

    const pages = previewRef.current.querySelectorAll(".bd-page");
    const pdf = new jsPDF("p", "pt", "a4");

    for (let i = 0; i < pages.length; i++) {
      const canvas = await html2canvas(pages[i], {
        scale: 2,
        useCORS: false,
        allowTaint: false,
        backgroundColor: null,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    }

    pdf.save("biodata.pdf");
  };

  return (
    <div className="preview-outer">
      <div className="preview-scale">
        <div ref={previewRef} className="maincontainer">
          <BiodataPreview
            sections={sections}
            template={template}
            userImage={userImage}
            onImgLoad={() => setImgLoaded(true)}
          />
        </div>
      </div>

<div class="bg-white p-3 mt-3 mb-4 rounded-lg text-center shadow-sm d-flex justify-content-end gap-2 ms-auto w-75">
        <button className="btn btn-md btn-primary" onClick={downloadPDF}>
          Download Biodata
        </button>

        <button
          className="btn btn-md btn-primary mx-2"
          onClick={() => setShowModal(true)}
        >
          Change Template
        </button>
      </div>

      {showModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Select Biodata Template</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <TemplateSelector
                    selected={template}
                    onSelect={(tpl) => {
                      onTemplateChange(tpl);
                      setShowModal(false);
                      setImgLoaded(false);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
      
    </div>

  );
}
